var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_test_miqube_in_transport_ui_remoteEntry_js_6720dcec__;